import { createSlice } from "@reduxjs/toolkit";

const selectedDigitalTwinSlice = createSlice({
  name: "selectedDigitalTwin",
  initialState: {
    field: null,
    farm: null,
    plants: null,
    livestock: null,
    singlePlant: null,
    singleLivestock: null,
  },
  reducers: {
    setDTField(state, action) {
      state.field = action.payload;
    },
    setDTFarm(state, action) {
      state.farm = action.payload;
    },
    setPlants(state, action) {
      state.plants = action.payload;
    },
    setLivestock(state, action) {
      state.livestock = action.payload;
    },
    setSinglePlant(state, action){
      state.singlePlant = action.payload;
    },
    setSingleLivestock(state, action){
      state.singleLivestock = action.payload;
    },
    clearDTField(state) {
      state.field = null;
      state.farm = null;
      state.plants = null;
      state.livestock = null;
      state.singlePlant = null;
      state.singleLivestock = null;
    },
  },
});

export const {
  setDTField,
  setDTFarm,
  clearDTField,
  setPlants,
  setLivestock,
  setSinglePlant,
  setSingleLivestock,
} = selectedDigitalTwinSlice.actions;
export default selectedDigitalTwinSlice.reducer;
